/* eslint-disable */

import Multiselect from 'vue-multiselect'
import Vue from 'vue'
import { mapGetters } from "vuex";
import readXlsxFile from 'read-excel-file'
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
Vue.component('multiselect', Multiselect)

export default {
  name: 'user-email-template',
  components: {
    Multiselect
  },
  props: [],
  data () {
    return {
      selectUser:'',
      users:[],
      subject:'',
      message:`<table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center" background="#fff1e5"
      style="background:#fff1e5;border:0px;color: #000000;">
      <style>
        a{color:#000000;text-decoration:none;}
      </style>
      <tbody>
        <tr>
          <td background="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/useradmin_bg.58c6da5d.jpg"
            valign="top"
            style="background-image: url(https://oddvega-public-content.s3.ca-central-1.amazonaws.com/useradmin_bg.58c6da5d.jpg);background-position: top center;background-repeat: no-repeat;background-size:cover;background-attachment:fixed;border:0px;padding: 20px;color: inherit;">
            <div style="color:#ffffff;text-align:center;">
              <table cellpadding="0" cellspacing="0" border="0" width="100%"
                background="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/email_transparent_bg.png"
                style="text-align: left;margin-top:0px;background-image:url('https://oddvega-public-content.s3.ca-central-1.amazonaws.com/email_transparent_bg.png');border-radius: 3px;padding:0px;margin-left:auto;margin-right:auto;margin-top:0;margin-bottom:0;font-size:16px;max-width:650px;width:100%;box-sizing:border-box;line-height: 1.3;background-repeat:no-repeat;background-size:100% 100%;border:0px;color:inherit;text-align:left;">
                <tr>
                  <td style="border:0px;padding:15px;color: inherit;">
                    <table cellpadding="0" cellspacing="0" border="0" width="100%" style="border:0px;color: inherit;">
                      <tr>
                        <td height="50" align="center" style="border:0px;padding:15px 0 15px;"><img
                            src="https://oddvega-public-content.s3.ca-central-1.amazonaws.com/oddvega-logo-new.png"
                            width="150" height="" alt="" style="display:inline-block;border:0px;"></td>
                      </tr>
                      <tr>
                        <td style="color:inherit;border:0px;padding-bottom: 20px;font-size:15px;">
                          <h5 style="font-size: 20px;font-weight:600;margin: 0px;">Hi {{name}},</h5>
                        </td>
                      </tr>
                      <tr>
                        <td style="box-sizing:border-box;padding:0px;border:0px">
                          <table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center"
                            style="border:0px;">
                            <tr>
                              <td style="background:#000000;padding:10px 15px;border:0px;">
                                <table width="100%" border="0" cellspacing="0" cellpadding="0" cellpadding="0"
                                  align="center" style="border:0px;">
                                  <tr>
                                    <td
                                      style="text-align: center;margin: 0;box-sizing:border-box;border:0px;padding-top:0;padding-bottom:0;">
                                      <table border="0" cellspacing="0" cellpadding="0" cellpadding="0" align="center"
                                        style="border:0px;text-align:center;margin:0 auto;">
                                        <tr>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/contact-us/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Contact Us</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/contact-us/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">About Us</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="javascript:void(0)" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Terms of Use</a>
                                          </td>
                                          <td
                                            style="box-sizing:border-box;border:0px;padding-left:3px;padding-right:3px;text-align: center;padding-top:0;padding-bottom:0;">
                                            <a href="https://www.oddvega.com/privacy-policy/" style="color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;display: inline-block;
    vertical-align: middle;">Privacy Policy</a>
                                          </td>
                                        </tr>
                                      </table>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      style="text-align:center;color:#ffffff;font-family:'Muli', Arial,sans-serif;font-size:14px;line-height:1;padding-top:6px;margin:0px;box-sizing:border-box; border:0px;padding-bottom:0px;">
                                      © Oddboot Technologies Inc. 2020
                                    </td>
                                  </tr>
                                </table>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                      <tr>
                        <td
                          style="text-align: center;margin-top:0px;margin-bottom:0px;padding-top:5px;box-sizing:border-box;border:0px">
                          <a href="#"
                            style="color:inherit;font-family:'Muli', Arial,sans-serif;font-size:14px;text-decoration:underline;">Unsubscribe</a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>`,
      userList:{},
      userListResults:[], 
      value: [],
      options: [],
      submitted:false,
      multiselect:false,
      config: {
        events: {
          initialized: function () {
            console.log('initialized')
          }
        }
      },
      confirmedSendMail:false,
      preview_box:false,
      UnsubscribedMultiple:false,
      unsubScribedmultiple:'',
      unsubScribedmultipleMail:[],
      unsubScribedmultiple_popup:false,
      excelImportDataList:[],
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      readExcelFileLoader:false
    }
  },
  computed: {
    ...mapGetters([
      'getuserListDetailsState'
    ]),
    getUserList() {
      this.userList = this.$store.getters.getuserListDetailsState.data
      return this.userList
    },
    setIntialsState(){
      if(this.userList != undefined){
        this.userListResults = this.userList.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }
  },
  mounted () {
    this.getUserList
    this.setIntialsState
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('message',{
        height:350,
        allowedContent:true,
        onLoad: function() {
          CKEDITOR.addCss(
              'a{' +
                  'color: #ffffff' +
               '}'
          );
      }
      });
      CKEDITOR.instances['message'].on('change', () => {
        var content1Length = CKEDITOR.instances['message'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          this.message = CKEDITOR.instances['message'].getData()
        }else{
          this.message = ''
        }
      })
    },
    onChange(value) {
      if(this.selectUser == 'Select Multiple'){
        this.multiselect = true
        this.UnsubscribedMultiple = false
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        this.multiselect = false
        this.UnsubscribedMultiple = true
        this.value = ''
      }else{
        this.multiselect = false
        this.UnsubscribedMultiple = false
        this.value = ''
        this.unsubScribedmultipleMail = []
        this.excelImportDataList = []
      }
    },
    
    validateCreateUserBeforeSubmit(){
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          this.confirmedSendMail = true
          $('body').addClass('email_sent_popup')
        }
      });
    },
    addTag (newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.options.push(tag)
      this.value.push(tag) 
    },
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    yesConfirmed(){
      if(this.selectUser == 'Select Multiple'){
        for(var i = 0; i < this.value.length; i++){
          this.users.push(this.value[i].id)
        }
        let data = {
          subject: this.subject,
          message: this.message,
          users:this.users
        }
        this.$store.dispatch('sentMultipleUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          // this.message = ''
          this.users = []
          this.$validator.reset();
        }).catch((err) => {})
      }else if(this.selectUser == 'Unsubscribed Multiple'){
        let data = {
          subject: this.subject,
          message: this.message,
          users:[]
        }
        if(this.excelImportDataList.length > 0){
          Object.keys(this.excelImportDataList).map((index) => {
            if(this.reg.test(this.excelImportDataList[index]) == true){
              data.users.push(this.excelImportDataList[index])
            }
          });
        }
        if(this.unsubScribedmultipleMail.length > 0){
          data.users.push(this.unsubScribedmultipleMail);
        }
        this.$store.dispatch('sentUnsubscribedMultipleUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.users = [],
          this.unsubScribedmultipleMail = []
          this.excelImportDataList = []
          this.$validator.reset();
        }).catch((err) => {})
      }
      else{
        let data = {
          subject: this.subject,
          message: this.message,
        }
        this.$store.dispatch('sentAllUserEmailFun', data).then((res) => {
          toast.success(res.data.msg);
          $('body').removeClass('email_sent_popup')
          this.submitted = false;
          this.confirmedSendMail = false
          this.subject = ''
          this.users = ''
          this.$validator.reset();
        }).catch((err) => {})
      }
      return;
    },
    cancleConfirmed(){
      $('body').removeClass('email_sent_popup')
      this.submitted = false;
      this.confirmedSendMail = false
    },
    previewBtn(){
      this.preview_box = true
      $('body').addClass('email_sent_popup')
      setTimeout(()=>{
      document.getElementById("mailcode").innerHTML = this.message;
      },200)
    },
    closePreviewBtn(){
      this.preview_box = false
      $('body').removeClass('email_sent_popup')
    },
    unsubScribedmultipleMailPopupFun(){
      this.unsubScribedmultiple_popup = true
      $('body').addClass('email_sent_popup')
    },
    unsubScribedmultipleMailClosePopupFun(){
      this.unsubScribedmultiple_popup = false
      $('body').removeClass('email_sent_popup')
      document.getElementById("importEmail").value = null;
    },
    unsubScribedmultipleFun(e){
      this.unsubScribedmultipleMail.push(this.unsubScribedmultiple)
      this.unsubScribedmultiple = ''
      this.$validator.reset();
    },
    removeAttributes : function (index) {
      Vue.delete(this.unsubScribedmultipleMail, index);
    },
    handleExcelFileUpload(event) {
      this.readExcelFileLoader = true
      this.excelImportDataList = []
      readXlsxFile(event.target.files[0]).then((res) => {
        this.excelImportDataList = res
        this.readExcelFileLoader = false
      })
    },
    isEmailValid(email) {
      return this.reg.test(email);
    },
    removeImportAttributes (index) {
      Vue.delete(this.excelImportDataList, index);
      
    },
    removeImportAttributesInPopup (index) {
      Vue.delete(this.excelImportDataList, index);
      if(this.excelImportDataList.length == 1){document.getElementById("importEmail").value = null;}
      
    },
    addImportedEMailFun(e){
      this.unsubScribedmultipleMail.push(this.excelImportDataList)
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
      this.$validator.reset();
    },
    removeImportedEMailFun(){
      this.excelImportDataList = []
      document.getElementById("importEmail").value = null;
    }
  },
  watch:{
    getUserList() {
      this.userList = this.$store.getters.getuserListDetailsState.data
      return this.userList
    },
    setIntialsState(){
      if(this.userList != undefined){
        this.userListResults = this.userList.results
        for(var i = 0; i < this.userListResults.length; i++){
          this.options.push({first_name:this.userListResults[i].first_name,last_name:this.userListResults[i].last_name,email:this.userListResults[i].email, id : this.userListResults[i].id})
        }
      }
    }
  }
}